// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var isFullNameValid = function (fullName) {
    var parts = Data_Array.filter((function () {
        var $0 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        return function ($1) {
            return $0(Data_String_Common["null"]($1));
        };
    })())(Data_String_Common.split(" ")(fullName));
    return Data_Array.length(parts) >= 2;
};
var emailRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(Data_Show.show(Data_Show.showString)(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data_String_Regex_Flags.noFlags));
var isEmailSyntaxValid = /* #__PURE__ */ Data_String_Regex.test(emailRE);
export {
    isFullNameValid,
    isEmailSyntaxValid
};
//# sourceMappingURL=index.js.map
